
import { Fragment } from "react";
import { Link } from "react-router-dom";
import { BsChevronLeft } from "react-icons/bs";
const LinkBox = ({ data }) => {

    return (
        <Fragment>
            <div className="d-flex flex-alig-items-center mt-2 py-3 px-2 border" style={{ boxShadow: "0px 4px 5px 0px #a3a3a3" }}>
                <span className="nfs-13 fw500">
                    {data.label}
                </span>
                <Link to={data.link} onClick={data.onClick} state={data.state} className="mr-auto text-primary nfs-12 fw300">
                    مشاهده
                    <BsChevronLeft className="mr-2" size={20} />
                </Link>
            </div>

        </Fragment >
    )
};

export default LinkBox;
